export type MealSlot = 'breakfast' | 'lunch' | 'snack' | 'dinner' | 'supper';
export const MEAL_SLOTS: MealSlot[] = ['breakfast', 'lunch', 'snack', 'dinner', 'supper'];
/** rótulo de rota: /comida?refeicao=almoco */
export const SLOT_ROUTE: Record<MealSlot, string> = {
  breakfast: 'cafe',
  lunch: 'almoco',
  snack: 'lanche',
  dinner: 'jantar',
  supper: 'ceia',
};
export const ROUTE_SLOT: Record<string, MealSlot> = Object.fromEntries(
  Object.entries(SLOT_ROUTE).map(([k, v]) => [v, k as MealSlot]),
);

export type FoodCategory = 'marmita' | 'complement' | 'ingredient';
export type StockCategory = 'marmita' | 'complement' | 'market' | 'supplement' | 'prepared';
export type StockLocation = 'freezer' | 'fridge' | 'pantry';
export type MovementReason = 'purchase' | 'consume' | 'move' | 'adjust' | 'waste' | 'prepare' | 'undo';
export type OrderVendor = 'livup' | 'market';
export type OrderStatus = 'draft' | 'ordered' | 'received' | 'cancelled';
export type EquipmentKind = 'machine' | 'cardio' | 'bodyweight';
export type SessionStatus = 'in_progress' | 'done' | 'abandoned';
export type SleepBucket = 'lt6' | 'h6to7' | 'h7to8' | 'h8plus';
export const SLEEP_LABEL: Record<SleepBucket, string> = {
  lt6: '< 6 h',
  h6to7: '6–7 h',
  h7to8: '7–8 h',
  h8plus: '8 h+',
};
export type PhotoPose = 'front' | 'side' | 'back';
export type StudyMethod = 'app' | 'cards' | 'other';
export type StudySource = 'timer' | 'manual' | 'review';
export type AlertTone = 'warn' | 'gym' | 'water' | 'study' | 'good' | 'info';
export type AlertTrigger = 'schedule' | 'event' | 'condition';
export type AdjustmentKind = 'kcal_minus' | 'kcal_plus' | 'early_deload';
export type NoteType = 'kana' | 'kanji' | 'vocab_ja' | 'vocab';
export type CardTemplate = 'sound' | 'write' | 'meaning' | 'reading' | 'read' | 'recall' | 'understand' | 'say';
export type CardState = 'new' | 'learning' | 'review' | 'relearning';

/** Ordem dos tons no Hoje (5.15). */
export const TONE_ORDER: AlertTone[] = ['warn', 'gym', 'study', 'water', 'info', 'good'];
